export default "__VITE_ASSET__CN58i97W__"